import dayjs from 'dayjs'

const calculateAge = (dateOfBirth: string): number => {
  return dayjs().diff(dayjs(dateOfBirth), 'years')
}

export const getAllowedCategoriesVelthuis = (
  dateOfBirth: string,
): string[] | 'all' | null => {
  const age = calculateAge(dateOfBirth)
  if (age < 14) {
    return null
  }
  if (age >= 14 && age < 18) {
    return ['HUID']
  }

  return 'all'
}

export const getAllowedTreatmentsVelthuis = (
  dateOfBirth: string,
): string[] | 'all' | null => {
  const age = calculateAge(dateOfBirth)

  if (age < 14) {
    return null
  }
  if (age >= 14 && age < 18) {
    return [
      'CON_H_COU',
      'CON_H_FIL',
      'CON_H_LO',
      'CON_H_HV',
      'CON_G_HUIDANALYSE',
      'CON_H_AA',
      'CON_H_HB',
    ]
  }
  return 'all'
}

export const isValidDateOfBirth = (
  dateOfBirth: string,
  treatment: string,
): boolean => {
  const allowedTreatments = getAllowedTreatmentsVelthuis(dateOfBirth)

  if (allowedTreatments === 'all') {
    return true
  }
  if (allowedTreatments === null) {
    return false
  }
  return allowedTreatments.includes(treatment)
}

export const isConsentRequiredVelthuis = (dateOfBirth: string): boolean => {
  const age = calculateAge(dateOfBirth)

  return age >= 14 && age < 18
}
